/**
 * @file 快速上手数据
 * @author FengGuang(fengguang01@baidu.com)
 */
import img1 from '../../../../images/feedback/install.png';
import img2 from '../../../../images/feedback/bug.png';
import img3 from '../../../../images/feedback/cooperation.png';

import {IPictureCard} from '../../../../components/picture-card/PictureCard';


const contactsListData: IPictureCard[] = [
    {
        title: '安装、使用问题',
        text: '如果您在安装和使用过程中遇到了技术问题，欢迎您加入飞桨官方QQ群（703252161）',
        img: img1,
        link: 'https://qm.qq.com/cgi-bin/qm/qr?k=HdaKHtbguIEsJBucMhelGPD-oJcnHCHE&authKey=imoc4geIJsdBOLriipWTo8RRaH0/kL2AUrfBhonan9FhcpK7NgYI2gfM2VNVONK',
        target: '_blank',
        tagText: '去官方QQ群（703252161）中提问'
    },
    {
        title: 'Bug和建议',
        text: '飞桨已在Github开源，如果您在使用过程中发现了Bug或对我们有任何建议，欢迎您在Github中提交Issue',
        img: img2,
        link: 'https://github.com/PaddlePaddle/Paddle/issues/new/choose',
        target: '_blank',
        tagText: '反馈到GitHub'
    },
    {
        title: '企业合作',
        text: '飞桨为企业提供多种技术服务并已和不同行业的企业伙伴建立合作关系，我们期待与您的合作',
        img: img3,
        link: '/consultationandcooperation',
        tagText: '注册成为我们的合作伙伴'
    }
];

export default contactsListData;
